// @flow

import React from "react";
import type { SearchContainerState } from "../utils/_types";

const SearchContext = React.createContext<SearchContainerState>({
  results: [],
  translations: {},
  filters: {},
  setFilters: () => {},
});

export default SearchContext;
